import { initDatadog } from '@pesto/features';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import './index.css';
import { ApolloProviderWrapper } from './providers/Apollo';
import ErrorBoundary from './providers/ErrorBoundary';
import { QueryProvider } from './providers/QueryProvider';

initDatadog({
  applicationId: 'ae4ee763-bbcf-4e84-a303-b21bda48e80f',
  clientToken: 'pubabafeb5f30f05e2296e8d51f8563db27',
  service: 'starlink-control',
  env: import.meta.env.VITE_ENV ?? 'local',
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <ErrorBoundary>
        <ApolloProviderWrapper>
          <QueryProvider>
            <App />
          </QueryProvider>
        </ApolloProviderWrapper>
      </ErrorBoundary>
    </BrowserRouter>
  </StrictMode>,
);
